import TORR_P28A161 from './perf_TORR_P28A-161.json'
import TORR_P28A181 from './perf_TORR_P28A-181.json'
import TORR_P28R201 from './perf_TORR_P28R-201.json'
import TORR_P28U201 from './perf_TORR_P28U-201.json'

import TODR_P28A161 from './perf_TODR_P28A-161.json'
import TODR_P28A181 from './perf_TODR_P28A-181.json'
import TODR_P28R201 from './perf_TODR_P28R-201.json'
import TODR_P28U201 from './perf_TODR_P28U-201.json'

import CRUISE_TAS_P28A161 from './perf_CruiseTAS_P28A-161.json'
import CRUISE_TAS_P28A181 from './perf_CruiseTAS_P28A-181.json'
import CRUISE_TAS_P28R201 from './perf_CruiseTAS_P28R-201.json'
import CRUISE_TAS_P28U201 from './perf_CruiseTAS_P28U-201.json'

import FUEL_P28A161 from './perf_Fuel_P28A-161.json'
import FUEL_P28A181 from './perf_Fuel_P28A-181.json'
import FUEL_P28R201 from './perf_Fuel_P28R-201.json'
import FUEL_P28U201 from './perf_Fuel_P28U-201.json'

import CLIMB_RATE_P28A161 from './perf_ClimbRate_P28A-161.json'
import CLIMB_RATE_P28A181 from './perf_ClimbRate_P28A-181.json'
import CLIMB_RATE_P28R201 from './perf_ClimbRate_P28R-201.json'
import CLIMB_RATE_P28U201 from './perf_ClimbRate_P28U-201.json'

import LDR_P28A161 from './perf_LDR_P28A-161.json'
import LDR_P28A181 from './perf_LDR_P28A-181.json'
import LDR_P28R201 from './perf_LDR_P28R-201.json'
import LDR_P28U201 from './perf_LDR_P28U-201.json'

const PERF_CHART_DATA = {
    "P28A-161": {
        "TORR": TORR_P28A161,
        "TODR": TODR_P28A161,
        "CRUISE_TAS": CRUISE_TAS_P28A161,
        "FUEL": FUEL_P28A161,
        "CLIMB_RATE": CLIMB_RATE_P28A161,
        "LDR": LDR_P28A161
    },
    "P28A-181": {
        "TORR": TORR_P28A181,
        "TODR": TODR_P28A181,
        "CRUISE_TAS": CRUISE_TAS_P28A181,
        "FUEL": FUEL_P28A181,
        "CLIMB_RATE": CLIMB_RATE_P28A181,
        "LDR": LDR_P28A181
    },
    "P28R-201": {
        "TORR": TORR_P28R201,
        "TODR": TODR_P28R201,
        "CRUISE_TAS": CRUISE_TAS_P28R201,
        "FUEL": FUEL_P28R201,
        "CLIMB_RATE": CLIMB_RATE_P28R201,
        "LDR": LDR_P28R201
    },
    "P28U-201": {
        "TORR": TORR_P28U201,
        "TODR": TODR_P28U201,
        "CRUISE_TAS": CRUISE_TAS_P28U201,
        "FUEL": FUEL_P28U201,
        "CLIMB_RATE": CLIMB_RATE_P28U201,
        "LDR": LDR_P28U201
    }
}

export function getChart(type, chart) {
    return PERF_CHART_DATA[type][chart];
}